module.exports = __webpack_public_path__ + "static/media/2DGACM1.d2c29801.jpg";